import { Injectable } from '@angular/core';

import { KnownPerformanceMarks } from './performance.service';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class ApiConfigurationDataService {
    public shellAndConfigData: any;
    private shellAndConfigResponse: Promise<any>;
    private initialized: boolean;

    constructor(
        private readonly windowService: WindowService
    ) {
        this.initialize();
    }

    public getShellAndConfigPromise(): Promise<any> {
        window.queuedMarks = window.queuedMarks || [];
        window.performance && window.performance.mark && window.performance.mark(KnownPerformanceMarks.AppInitializationComplete);
        window.queuedMarks.push({markName: KnownPerformanceMarks.AppInitializationComplete, measureFrom: KnownPerformanceMarks.AppBeginBootstrap});
        return this.shellAndConfigResponse;
    }

    public reset() {
        this.setShellAndConfigPromise();
    }

    private initialize() {
        if (this.initialized) {
            return;
        }

        this.initialized = true;
        this.setShellAndConfigPromise();
    }

    private async fetchShellAndConfig(): Promise<any> {
        const apiResponse = await this.windowService.nativeWindow.shellAndConfigResponse;
        if (apiResponse) {
            try {
                // V2 API response is an object instead of string, so keeping the try catch block here while we transition
                this.shellAndConfigData = JSON.parse(apiResponse);
            } catch {
                this.shellAndConfigData = apiResponse;
            }
        }
    }

    private setShellAndConfigPromise() {
        this.shellAndConfigResponse = this.fetchShellAndConfig();
    }
}
